var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"boxVideo"},[_c('video',{attrs:{"playsinline":"","autoplay":"","muted":"","loop":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":require("../assets/videos/vinheta_web.mp4"),"type":"video/mp4"}}),_vm._v(" Your browser does not support HTML5 video. ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }